module.exports = __webpack_public_path__ + "static/fonts/DaimlerCAC-Regular.9d6fbd2c.ttf";